<template>
    <el-dialog class="elModal" append-to-body :title="modal.title" :visible.sync="isshow" v-if="isshow" :show-close="modal.showCancelButton" :close-on-click-modal="false" v-on:close="cancel()" lock-scroll center>
        <slot></slot>
        <div slot="footer" class="dialog-footer" style="min-height:76px;text-align: right;" v-if="modal.showCustomButton || modal.showCustomButton1 || modal.showCancelButton || modal.showConfirmButton">
            <el-button style="padding: 12px;font-size: 20px;min-width: 100px;margin-left: 10px;" :style="{'float':modal.customButtonFloat}" v-if="modal.showCustomButton" :icon="modal.customButtonIcon" :type="modal.customButtonClass" @click="customClick()">{{modal.customButtonText}}</el-button>
            <el-button style="padding: 12px;font-size: 20px;min-width: 100px;margin-left: 10px;" :style="{'float':modal.customButtonFloat1}" v-if="modal.showCustomButton1" :icon="modal.customButtonIcon1" :type="modal.customButtonClass1" @click="customClick1()">{{modal.customButtonText1}}</el-button>
            <el-button style="padding: 12px;font-size: 20px;min-width: 140px;" v-if="modal.showCancelButton" icon="el-icon-error" :type="modal.cancelButtonClass" @click="cancel()">{{modal.cancelButtonText}}</el-button>
            <el-button style="padding: 12px;font-size: 20px;min-width: 140px;" v-if="modal.showConfirmButton" icon="el-icon-success" :type="modal.confirmButtonClass" @click="submit(modal.confirmButtonText)">{{modal.confirmButtonText}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
//import BScroll from '@better-scroll/core'

export default {
    name: "elModal",
    //props: ["options", "resultdata"],
    computed: {
        modal() {
            let modal = this.options;
            if (this.options2) modal = this.options2;
            if (modal) {
                modal = {
                    title: modal.title || "提示",
                    showCustomButton: typeof modal.showCustomButton == "undefined" ? false : modal.showCustomButton,
                    customButtonClass: modal.customButtonClass ? modal.customButtonClass : "warning",
                    customButtonText: modal.customButtonText ? modal.customButtonText : "自定义",
                    customClick: modal.customClick ? modal.customClick : undefined,
                    customButtonIcon: modal.customButtonIcon ? modal.customButtonIcon : 'el-icon-info',
                    customButtonFloat: modal.customButtonFloat ? modal.customButtonFloat : 'left',


                    showCustomButton1: typeof modal.showCustomButton1 == "undefined" ? false : modal.showCustomButton1,
                    customButtonClass1: modal.customButtonClass1 ? modal.customButtonClass1 : "warning",
                    customButtonText1: modal.customButtonText1 ? modal.customButtonText1 : "自定义",
                    customClick1: modal.customClick1 ? modal.customClick1 : undefined,
                    customButtonIcon1: modal.customButtonIcon1 ? modal.customButtonIcon1 : 'el-icon-info',
                    customButtonFloat1: modal.customButtonFloat1 ? modal.customButtonFloat1 : 'left',

                    showCancelButton: typeof modal.showCancelButton == "undefined" ? true : modal.showCancelButton,
                    cancelButtonClass: modal.cancelButtonClass ? modal.cancelButtonClass : "",
                    cancelButtonText: modal.cancelButtonText ? modal.cancelButtonText : "取消",
                    showConfirmButton: typeof modal.showConfirmButton == "undefined" ? true : modal.showConfirmButton,
                    confirmButtonClass: modal.confirmButtonClass ? modal.confirmButtonClass : "primary",
                    confirmButtonText: modal.confirmButtonText ? modal.confirmButtonText : "确定",
                    beforeClose: modal.beforeClose ? modal.beforeClose : undefined,
                };
            } else {
                // 使用时没有传递参数
                modal = {
                    title: "提示",
                    showCustomButton: false,
                    customButtonClass: 'warning',
                    customButtonText: '自定义',
                    customClick: undefined,
                    customButtonIcon: 'el-icon-info',

                    showCustomButton1: false,
                    customButtonClass1: 'warning',
                    customButtonText1: '自定义',
                    customClick1: undefined,
                    customButtonIcon1: 'el-icon-info',

                    showCancelButton: true,
                    cancelButtonClass: "btn-default",
                    cancelButtonText: "取消",

                    showConfirmButton: true,
                    confirmButtonClass: "btn-active",
                    confirmButtonText: "确定",
                    beforeClose: undefined,
                };
            }
            return modal;
        }
    },
    data() {
        return {
            isshow: false, // 是否显示模态框
            resolve: "",
            reject: "",
            promise: "", // 保存promise对象
            options2: {},
            //bs: null,
        };
    },
    methods: {
        async submit(text) {
            let result = undefined;
            if (this.modal.beforeClose) {
                result = await this.modal.beforeClose(this.resultdata, text, this);
                if (!result) return;
            }
            this.isshow = false;

            this.resolve(text);
        },
        customClick() {
            if (this.modal.customClick) this.modal.customClick();
        },
        customClick1() {
            if (this.modal.customClick1) this.modal.customClick1();
        },
        async cancel() {
            try {
                this.isshow = false;
                if (this.reject) this.reject();
            } catch (error) {
                console.log(error);
            }
        },
        show(option) {
            option = option || {};
            if (option) this.options2 = option;
            this.isshow = true;
            this.promise = new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
            setTimeout(() => {
                //延时执行,首次加载的时候没有dom,这里会报错
                try {
                    var tmp = this.$el.getElementsByClassName('autofocus');
                    if (tmp.length > 0) tmp = tmp[0].children[0];
                    if (tmp && tmp.focus) tmp.focus();
                    if (tmp && tmp.select) tmp.select();

                    var tmp2 = this.$el.getElementsByClassName('numberKeyboard');

                } catch (error) {
                    console.log(error);
                }
                if (option.onShow) option.onShow();
            }, 200);  //延时让窗体显示出来
            return this.promise; //返回promise对象,给父级组件调用
        },
        isShow() {
            return this.isshow;
        }
    }
};
</script>

<style lang="less">
.elModal {
    text-align: center;

    > div {
        width: initial;
        display: inline-block; //自动宽度
    }

    //对话框居中
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-dialog {
        margin: auto !important;
    }
}

//
.big-dialog .el-dialog {
    width: 60%;
    min-width: 600px;
}
.fulldialog .el-dialog {
    width: 90% !important;
}
.fixmodaltop .el-dialog {
    margin-top: 10px !important;
}
/* .fulldialog .el-dialog__body {
    padding: 0 !important;
} */
.elModal-400 .el-dialog {
    min-width: 400px;
}
.elModal-500 .el-dialog {
    min-width: 500px;
}
.elModal-600 .el-dialog {
    min-width: 600px;
}
// .elModal .el-dialog {
//     width: 600px;
// }
// .el-dialog {
//     margin-top: 60px !important;
// }

.elModal {
    > div {
        // min-width: initial !important;
        max-width: 90%;
    }
}
.el-dialog__header {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    padding-right: 40px;
}

/*对话框 */
.dialog-60 .el-dialog {
    width: 60%;
    min-width: 800px;
}
.dialog-80 .el-dialog {
    width: 80%;
    min-width: 800px;
}
.dialog-90 .el-dialog {
    width: 90%;
    min-width: 800px;
}
.dialog-100 .el-dialog {
    width: 100%;
    min-width: 800px;
}
.dialog-top10 .el-dialog {
    margin-top: 10px !important;
}
.dialog-top0 .el-dialog {
    margin-top: 0 !important;
}
.bom-dialog {
    .el-dialog {
        width: 500px !important;
    }
}

// 对话框内容过长时,中间部分滚动,最底部按钮一直都能显示
.el-dialog {
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    .el-dialog__body {
        flex: 1 !important;
        overflow: auto !important;

        display: flex !important;
        flex-direction: column !important;
    }
}
</style>